/**
 * 구독 일시중지 모달
 * FSD: features/subscription/subscription-manage/ui
 */

import React, { useState } from 'react';

interface PauseModalProps {
  onPause: (reason?: string) => Promise<void>;
  onClose: () => void;
}

export const PauseModal: React.FC<PauseModalProps> = ({ onPause, onClose }) => {
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await onPause(reason || undefined);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>구독 일시중지</h2>
          <button className="close-button" onClick={onClose} disabled={isLoading}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <p>
            구독을 일시중지하면 다음 결제가 실행되지 않습니다.
            <br />
            언제든지 다시 재개할 수 있습니다.
          </p>

          <div className="form-group">
            <label htmlFor="reason">일시중지 사유 (선택사항)</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="일시중지 사유를 입력해주세요"
              rows={3}
              disabled={isLoading}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="confirm-button"
          >
            {isLoading ? '처리 중...' : '일시중지'}
          </button>
          <button onClick={onClose} disabled={isLoading} className="cancel-button">
            취소
          </button>
        </div>
      </div>
    </div>
  );
};
